import Step from 'shepherd.js/src/types/step';
import { offset } from '@floating-ui/dom';
import { SHEPHERD_CARD_TYPES } from '../model';
import { SHEPHERD_NEXT_BUTTON_CLASSES, SHEPHERD_PREVIOUS_BUTTON_CLASSES } from '../constants';

export namespace KanbanBoardScenario {
  export function getScenarioSteps(): Array<Step.StepOptions> {
    const attachShepherdStepCounterElement = this.attachShepherdStepCounterElement.bind(this);
    const attachShepherdCardElement = this.attachShepherdCardElement.bind(
      this,
      SHEPHERD_CARD_TYPES.COLUMN
    );
    const shepherdService = this.shepherdService;

    return [
      {
        id: 'kanbanBoardIntro',
        arrow: false,
        classes: 'shepherd-grid-modal shepherd-bottom-left',
        canClickTarget: false,
        buttons: [
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.INTRO.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.INTRO.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
            attachShepherdCardElement();
          },
        },
      },
      {
        id: 'kanbanBoardTabs',
        attachTo: {
          element: '.summary',
          on: 'bottom',
        },
        classes: 'shepherd-selected-link',
        canClickTarget: false,
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.TABS.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.TABS.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardFilters',
        attachTo: {
          element: '[data-at-kanban-filters]',
          on: 'bottom',
        },
        classes: 'shepherd-selected-link',
        canClickTarget: false,
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.FILTERS.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.FILTERS.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'snapshotSynchronize',
        canClickTarget: false,
        attachTo: {
          element: '[data-at-snapshot-synchronize]',
          on: 'bottom',
        },
        classes: 'shepherd-selected-link',
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.SYNCHRONIZE_BUTTON.TITLE'),
        text: [this.translateService.instant('+SHEPHERD.SYNCHRONIZE_BUTTON.DESCRIPTION')],
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardOptions',
        attachTo: {
          element: '[data-at-column-name="WorksProperly"] app-kanban-column-menu',
          on: 'left',
        },
        classes: 'shepherd-selected-link',
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          const element = document.getElementById('WorksProperly');
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        },

        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.OPTIONS.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.OPTIONS.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardAddColumn',
        attachTo: {
          element: '.add-column-tile',
          on: 'left',
        },
        canClickTarget: false,
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToRightEnd(document.getElementsByClassName('column-wrapper')[0]);
        },
        classes: 'shepherd-selected-link',
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.ADD_COLUMN.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.ADD_COLUMN.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardInstallationTile',
        attachTo: {
          element: '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile',
          on: 'left',
        },
        scrollTo: true,
        scrollToHandler: (): void => {
          const element = document.querySelector(
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile'
          );
          element.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        },
        canClickTarget: false,
        classes: 'shepherd-selected-link',
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.LIST_TILE.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.LIST_TILE.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardLastTileOptions',
        attachTo: {
          element:
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile .mat-mdc-menu-trigger',
          on: 'left',
        },
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElementInContainer(
            '[data-at-column-name="WorksProperly"] div.column__tiles',
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile .mat-mdc-menu-trigger'
          );
        },
        canClickTarget: false,
        classes: 'shepherd-selected-link',
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.TILE_OPTIONS.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.TILE_OPTIONS.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardUpgradeBadge',
        attachTo: {
          element:
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile .upgrade-pill',
          on: 'left',
        },
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElementInContainer(
            '[data-at-column-name="WorksProperly"] div.column__tiles',
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile .upgrade-pill'
          );
        },
        canClickTarget: false,
        classes: 'shepherd-selected-link',
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              shepherdService.next();
            },
          },
        ],
        showOn: (): boolean => {
          let elementPresent = document.querySelector(
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile .upgrade-pill'
          );

          return !!elementPresent;
        },
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.UPGRADE_BADGE.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.UPGRADE_BADGE.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardStatusBadges',
        attachTo: {
          element:
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile app-installation-tile-badges',
          on: 'left',
        },
        scrollTo: true,
        scrollToHandler: (): void => {
          this.scrollToElementInContainer(
            '[data-at-column-name="WorksProperly"] div.column__tiles',
            '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile app-installation-tile-badges'
          );
        },
        canClickTarget: false,
        classes: 'shepherd-selected-link',
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.NEXT'),
            action(): void {
              document
                .querySelector(
                  '[data-at-column-name="WorksProperly"] app-kanban-installation-list-tile > div'
                )
                ['click']();
              shepherdService.next();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.STATUS_TILE.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.STATUS_TILE.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
      {
        id: 'kanbanBoardQuickView',
        attachTo: {
          element: 'app-kanban-quick-view-wrapper',
          on: 'left',
        },
        canClickTarget: false,
        classes: 'shepherd-selected-link',
        floatingUIOptions: {
          middleware: [offset({ mainAxis: 20, crossAxis: 0 })],
        },
        buttons: [
          {
            classes: SHEPHERD_PREVIOUS_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.BACK'),
            action(): void {
              document.querySelector('app-kanban-quick-view-wrapper .header mat-icon')['click']();
              shepherdService.back();
            },
          },
          {
            classes: SHEPHERD_NEXT_BUTTON_CLASSES,
            text: this.translateService.instant('GENERAL.BUTTON.CLOSE'),
            action(): void {
              document.querySelector('app-kanban-quick-view-wrapper .header mat-icon')['click']();
              shepherdService.complete();
            },
          },
        ],
        title: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.QUICK_VIEW.TITLE'),
        text: this.translateService.instant('+SHEPHERD.KANBAN_BOARD.QUICK_VIEW.DESCRIPTION'),
        when: {
          show(): void {
            attachShepherdStepCounterElement();
          },
        },
      },
    ];
  }
}
